import "core-js/modules/es6.function.name";
import formValidateMixin from "../mixins/form-validate";
import ModalMixin from "../mixins/modal";
import Axios from 'axios';
export default {
  name: "sns-modal",
  props: ["title", "from", "value"],
  mixins: [formValidateMixin, ModalMixin],
  data: function data() {
    return {
      data: {
        client_name: "",
        hardware_version: "",
        lang: "zh-cn",
        license_interface: "",
        licensed_months: 1,
        licensed_num: 1,
        media_type: "",
        product_key: "",
        product_name: "",
        software_version: "",
        mcd: null
      },
      rules: {
        client_name: {
          type: "string",
          required: true,
          min: 2,
          max: 20
        },
        hardware_version: {
          type: "string",
          required: true
        },
        lang: {
          type: "enum",
          enum: ["zh-cn", "en"]
        },
        license_interface: {
          type: "string",
          required: true
        },
        licensed_months: {
          type: "integer",
          min: 1
        },
        licensed_num: {
          type: "integer",
          min: 1
        },
        media_type: {
          type: "string"
        },
        product_key: {
          type: "string",
          required: true
        },
        product_name: {
          type: "string",
          required: true
        },
        software_version: {
          type: "string",
          required: true
        }
      },
      loading: false
    };
  },
  methods: {
    onLoad: function onLoad() {},
    handleOk: function handleOk() {
      var _this = this;
      var data = this.data;
      this.loading = true;
      return Axios.post("activation/sns/", {
        name: data.name,
        permissions: data.permissions.slice(0)
      }).then(function () {
        return _this.loading = false;
      }, function (e) {
        _this.loading = false;
        throw e;
      });
    },
    resetData: function resetData() {
      this.$refs.form.resetFields();
      this.loading = false;
    }
  }
};